const prog = "https://img.icons8.com/ios-filled/50/ffffff/code.png";
const mech =
  "https://img.icons8.com/external-vitaliy-gorbachev-fill-vitaly-gorbachev/60/ffffff/external-wrench-labour-day-vitaliy-gorbachev-fill-vitaly-gorbachev.png";
const elect = "https://img.icons8.com/ios-filled/50/ffffff/electronics.png";
const pr =
  "https://img.icons8.com/external-smashingstocks-glyph-smashing-stocks/66/ffffff/external-online-marketing-network-and-communication-smashingstocks-glyph-smashing-stocks.png";

const department_contnet = [
  {
    id: 1,
    dep_name: "PROGRAMMING",
    imgURL: prog,
    topage: "/progammingDepartment",
    content: "A bunch of Geeks, who love coding.",
  },
  {
    id: 1,
    dep_name: "MECHANICAL",
    imgURL: mech,
    topage: "/MechenicalDepartment",
    content: "Our work begins when the code ends.",
  },

  {
    id: 1,
    dep_name: "ELECTRONICS",
    imgURL: elect,
    topage: "/ElectricalDepartment",
    content: "Our brains are wired to deliver the best.",
  },
  {
    id: 1,
    dep_name: "PR",
    imgURL: pr,
    topage: "/PublicRelations",
    content: "Getting attention to the right place!!.",
  },
];
export default department_contnet;
